import React from 'react';

const Heading = () => {
  return (
    <div className="pt-12 sm:pt-16 lg:pt-24">
      <div className="max-w-screen-xl px-4 mx-auto text-center sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto lg:max-w-none">
          <h2 className="text-lg font-semibold leading-6 tracking-wider text-gray-200 uppercase">
            Pricing
          </h2>
          <p className="mt-4 text-3xl font-extrabold leading-9 text-white sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none">
            Plans that work for your company
          </p>
        </div>
      </div>
    </div>
  );
};

export default Heading;
